import React from 'react';
import { LOGO_URL } from '../../data/siteData';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Logo AQUABLUENET Pressing"
                className="h-20 w-20 object-contain drop-shadow-lg"
              />
              <div>
                <h3 className="text-xl font-bold">AQUABLUENET</h3>
                <p className="text-sm text-gray-400">Pressing & Soin Textile</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Votre pressing de confiance à Longpont-sur-Orge et Mennecy. Nettoyage et repassage professionnels pour tous vos textiles. Carte <strong>CleanWay</strong> (5àSec business) acceptée.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Nettoyage à sec</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Repassage</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Teinturerie</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Robes de mariée</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a
                  href="mailto:pressingaquabluenet@gmail.com"
                  className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors font-semibold uppercase tracking-wider"
                  data-testid="footer-email-link"
                >
                  <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; 2024 PRESSING AQUABLUENET. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};
